import { useLocation } from 'react-router-dom';

/** True when the user is inside the isolated /demo/* sandbox (simulated data routes). */
export function useDemoSandbox(): boolean {
  const { pathname } = useLocation();
  return pathname === '/demo' || pathname.startsWith('/demo/');
}

export default useDemoSandbox;
